import DescargarXML from 'akasia-components/cliente/orden/seccion-header/DescargarXML';
import PropTypes from 'prop-types';
import React from 'react';
import { DropdownButton, Spinner } from 'react-bootstrap';

const HeaderComplementoPagoRecibido = ({ isActive, vUUIDComplemento, dFechaEmision, vRfcEmisor }) => {
    return (

        <div className="mb-1">
            <div className="d-flex justify-content-between align-items-center">

                <h5>📄 Factura Recibida → Complemento de Pago (REP)</h5>

                <div className="d-flex align-items-center">
                    {isActive === undefined || isActive === null ? (
                        <span className="me-2">
                            <Spinner animation="border" size="sm" variant="secondary" />
                        </span>
                    ) : (
                        <>
                            <span
                                className="me-2"
                                style={{
                                    width: '10px',
                                    height: '10px',
                                    borderRadius: '50%',
                                    backgroundColor: isActive ? 'green' : 'red',
                                    display: 'inline-block'
                                }}
                            ></span>
                            {isActive ? (
                                <DropdownButton
                                    variant="success"
                                    title="Complemento Activo"
                                    size="sm"
                                >
                                    <DescargarXML
                                        vUUIDFactura={vUUIDComplemento}
                                        dFechaEmision={dFechaEmision}
                                        vRfcEmisor={vRfcEmisor}
                                        esFacturaRecibida={true}
                                    />
                                </DropdownButton>
                            ) : (
                                <span className="text-danger">
                                    Complemento Cancelado
                                </span>
                            )}
                        </>
                    )}
                </div>
            </div>
            <hr></hr>
        </div >
    );
};

HeaderComplementoPagoRecibido.propTypes = {
    isActive: PropTypes.bool,
    vUUIDComplemento: PropTypes.string,
    dFechaEmision: PropTypes.string,
    vRfcEmisor: PropTypes.string
};

export default HeaderComplementoPagoRecibido;
